export * from "./platformDetector";
export * from "./usePlatformDetector";
